import { toast } from "react-toastify";
import { axiosClient } from "../shared/apiConfig";

export interface UsageReceiptDownload {
  url: string;
  fileName: string;
  expiresAt: string;
}

export async function openUsageReceiptDownload( url: string ) {
  try {
    const res = await axiosClient.get<UsageReceiptDownload>( url );
    window.open( res.data.url, "_blank", "noopener,noreferrer" );
  } catch {
    toast.error( "Receipt could not be loaded." );
  }
}

export function usageBillingReceiptUrl( orderId: number ) {
  return `/usage-billing/orders/${orderId}/receipt`;
}

export function monitorParkerUsageReceiptUrl( facilityId: number, parkerId: number, orderId: number ) {
  return `/monitor/facility/${facilityId}/parker/${parkerId}/order/${orderId}/usage-receipt`;
}
